/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
	AnnouncementCreateUpdateDTO,
	AnnouncementCreateUpdateDTOFromJSON,
	AnnouncementCreateUpdateDTOToJSON,
	AnnouncementDTO,
	AnnouncementDTOFromJSON,
	AnnouncementDTOToJSON,
	AnnouncementDTOPagedResponse,
	AnnouncementDTOPagedResponseFromJSON,
	AnnouncementDTOPagedResponseToJSON,
	AnnouncementForUserDTO,
	AnnouncementForUserDTOFromJSON,
	AnnouncementForUserDTOToJSON,
} from "../models";

export interface ApiAnnouncementCreatePostRequest {
	announcementCreateUpdateDTO?: AnnouncementCreateUpdateDTO;
}

export interface ApiAnnouncementDeleteAnnouncementIdDeleteRequest {
	announcementId: string;
}

export interface ApiAnnouncementGetAnnouncementByIdAnnouncementIdGetRequest {
	announcementId: string;
}

export interface ApiAnnouncementGetAnnouncementsGetRequest {
	searchTerm?: string;
	page?: number;
	pageSize?: number;
}

export interface ApiAnnouncementUpdateAnnouncementIdPutRequest {
	announcementId: string;
	announcementCreateUpdateDTO?: AnnouncementCreateUpdateDTO;
}

/**
 *
 */
export class AnnouncementApi extends runtime.BaseAPI {
	/**
	 */
	async apiAnnouncementCreatePostRaw(
		requestParameters: ApiAnnouncementCreatePostRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<void>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters["Content-Type"] = "application/json";

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/Announcement/Create`,
				method: "POST",
				headers: headerParameters,
				query: queryParameters,
				body: AnnouncementCreateUpdateDTOToJSON(
					requestParameters.announcementCreateUpdateDTO
				),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 */
	async apiAnnouncementCreatePost(
		requestParameters: ApiAnnouncementCreatePostRequest = {},
		initOverrides?: RequestInit
	): Promise<void> {
		await this.apiAnnouncementCreatePostRaw(requestParameters, initOverrides);
	}

	/**
	 */
	async apiAnnouncementDeleteAnnouncementIdDeleteRaw(
		requestParameters: ApiAnnouncementDeleteAnnouncementIdDeleteRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.announcementId === null ||
			requestParameters.announcementId === undefined
		) {
			throw new runtime.RequiredError(
				"announcementId",
				"Required parameter requestParameters.announcementId was null or undefined when calling apiAnnouncementDeleteAnnouncementIdDelete."
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/Announcement/Delete/{announcementId}`.replace(
					`{${"announcementId"}}`,
					encodeURIComponent(String(requestParameters.announcementId))
				),
				method: "DELETE",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 */
	async apiAnnouncementDeleteAnnouncementIdDelete(
		requestParameters: ApiAnnouncementDeleteAnnouncementIdDeleteRequest,
		initOverrides?: RequestInit
	): Promise<void> {
		await this.apiAnnouncementDeleteAnnouncementIdDeleteRaw(
			requestParameters,
			initOverrides
		);
	}

	/**
	 */
	async apiAnnouncementGetAnnouncementByIdAnnouncementIdGetRaw(
		requestParameters: ApiAnnouncementGetAnnouncementByIdAnnouncementIdGetRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<AnnouncementDTO>> {
		if (
			requestParameters.announcementId === null ||
			requestParameters.announcementId === undefined
		) {
			throw new runtime.RequiredError(
				"announcementId",
				"Required parameter requestParameters.announcementId was null or undefined when calling apiAnnouncementGetAnnouncementByIdAnnouncementIdGet."
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/Announcement/GetAnnouncementById/{announcementId}`.replace(
					`{${"announcementId"}}`,
					encodeURIComponent(String(requestParameters.announcementId))
				),
				method: "GET",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			AnnouncementDTOFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiAnnouncementGetAnnouncementByIdAnnouncementIdGet(
		requestParameters: ApiAnnouncementGetAnnouncementByIdAnnouncementIdGetRequest,
		initOverrides?: RequestInit
	): Promise<AnnouncementDTO> {
		const response =
			await this.apiAnnouncementGetAnnouncementByIdAnnouncementIdGetRaw(
				requestParameters,
				initOverrides
			);
		return await response.value();
	}

	/**
	 */
	async apiAnnouncementGetAnnouncementsGetRaw(
		requestParameters: ApiAnnouncementGetAnnouncementsGetRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<AnnouncementDTOPagedResponse>> {
		const queryParameters: any = {};

		if (requestParameters.searchTerm !== undefined) {
			queryParameters["SearchTerm"] = requestParameters.searchTerm;
		}

		if (requestParameters.page !== undefined) {
			queryParameters["Page"] = requestParameters.page;
		}

		if (requestParameters.pageSize !== undefined) {
			queryParameters["PageSize"] = requestParameters.pageSize;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/Announcement/GetAnnouncements`,
				method: "GET",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			AnnouncementDTOPagedResponseFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiAnnouncementGetAnnouncementsGet(
		requestParameters: ApiAnnouncementGetAnnouncementsGetRequest = {},
		initOverrides?: RequestInit
	): Promise<AnnouncementDTOPagedResponse> {
		const response = await this.apiAnnouncementGetAnnouncementsGetRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 */
	async apiAnnouncementGetForCurrentUserGetRaw(
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<Array<AnnouncementForUserDTO>>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/Announcement/GetForCurrentUser`,
				method: "GET",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			jsonValue.map(AnnouncementForUserDTOFromJSON)
		);
	}

	/**
	 */
	async apiAnnouncementGetForCurrentUserGet(
		initOverrides?: RequestInit
	): Promise<Array<AnnouncementForUserDTO>> {
		const response = await this.apiAnnouncementGetForCurrentUserGetRaw(
			initOverrides
		);
		return await response.value();
	}

	/**
	 */
	async apiAnnouncementUpdateAnnouncementIdPutRaw(
		requestParameters: ApiAnnouncementUpdateAnnouncementIdPutRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.announcementId === null ||
			requestParameters.announcementId === undefined
		) {
			throw new runtime.RequiredError(
				"announcementId",
				"Required parameter requestParameters.announcementId was null or undefined when calling apiAnnouncementUpdateAnnouncementIdPut."
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters["Content-Type"] = "application/json";

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/Announcement/Update/{announcementId}`.replace(
					`{${"announcementId"}}`,
					encodeURIComponent(String(requestParameters.announcementId))
				),
				method: "PUT",
				headers: headerParameters,
				query: queryParameters,
				body: AnnouncementCreateUpdateDTOToJSON(
					requestParameters.announcementCreateUpdateDTO
				),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 */
	async apiAnnouncementUpdateAnnouncementIdPut(
		requestParameters: ApiAnnouncementUpdateAnnouncementIdPutRequest,
		initOverrides?: RequestInit
	): Promise<void> {
		await this.apiAnnouncementUpdateAnnouncementIdPutRaw(
			requestParameters,
			initOverrides
		);
	}
}
